<template>
    <div id="scheduleComs">
        <schedule-coms :scheduleProp="scheduleProp" :currentRow="currentRow"></schedule-coms>
    </div>
</template>
<script>
    import scheduleComs from '../shedule.vue'
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        props:{
            currentRow:{
                type: Object,
                default: function() {
                    return {};
                }
            }
        },
        components:{
            scheduleComs
        },
        watch:{
            currentRow(){
                ajax.get(api.GENERICFUNC).then(res=>{
                    this.scheduleProp = {
                        functionUid: res.data,
                        userUid: "D2F17AC0-DF65-4DFF-8311-EBA7372FD2C7",
                        funApi: "/generic/impl?menu=V_SCHD_TASK"
                    }
                })
            }
        },
        created(){
//            获取menu funuid
            ajax.get(api.GENERICFUNC).then(res=>{
                this.scheduleProp = {
                        functionUid: res.data,
                        userUid: "D2F17AC0-DF65-4DFF-8311-EBA7372FD2C7",
                        funApi: "/generic/impl?menu=V_SCHD_TASK"
                }
            })
        },
        data(){
            return{
                scheduleProp:{}
            }
        },
    }
</script>